"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "ethers/5.0.29";
//# sourceMappingURL=_version.js.map